export const BlockPartyRegistrationForm = () => {
    return ( 
   
      <div class="flex justify-center items-center">
          <p class="text-carolina mt-44 mb-44 text-center text-4xl">Block Party Registration Form Coming Soon!!</p>
      </div>
      
    )
  };